export const SET_LOAN_STATUS = "SET_LOAN_STATUS";
export const REMOVE_LOAN_STATUS = "REMOVE_LOAN_STATUS";
